<!-- Help: Main Image Selection -->
<template>
	<div class="help-main">
		
		
			<div class="ico-box">
				<UniIcon 
					ico="star" 
					color="#369" 
					w="40"
					h="30"
					fit="1"
				/>
			</div>

		<div class="title">
			Primary Image for My Story
		</div>

		<div class="body">
			I am choosing the main image for my story seen in the Stories Listing.

			<br />
			<br />

			<div class="shot">
				<img src="../assets/img/screen_main_pic.jpg" />
			</div>

		</div>
						
		<hr />

	</div>
</template>


<script>
// import { eventBus } from '../main';
export default {
	data() {
		return {
			comp_name: 'app-info-main_img'
		};
	}
}
</script>


<style scoped>
	.help-main {
		height: 100%;
		overflow: hidden;
		color: #369;
		padding: 0px 10px 10px 10px;
		border: solid 0px #369;
	}

	.ico-box {
		display: inline-block;
		width: 30px;
		height: 30px;
		vertical-align: top;
		border: solid 0px #C30;
	}

	.title {
		display: inline-block;
		height: 40px;
		overflow: hidden;
		vertical-align: top;
		font-size: 18px;
		font-weight: bold;
		text-align: left;
		color: #369;
		padding: 5px;
		border: solid 0px #369;
	}

	.body {
		clear:both;
		color: #000;
		font-size: 15px;
		text-align: left;
		padding: 0px;
		border: solid 0px #369;
	}

	.shot {
		width: 280px;
		height: 450px;
		overflow: hidden;
		margin: 0 auto;
		border: solid 0px #C30;
	}
</style>
